import React from "react";
import { Helmet } from "react-helmet";

import SingleColumnDashView from "dashboard/components/SingleColumnDashView";
import { STATUS, SORT } from "config/constants";

export default function Published() {
  return (
    <div>
      <Helmet>
        <title>Published</title>
      </Helmet>

      <SingleColumnDashView
        pubStatus={"published"}
        defaultSort={SORT.BY_LAST_UPDATED}
        optionsForOrdering={[SORT.BY_LAST_UPDATED, SORT.BY_PUBLISHED_DATE]}
        optionsForStatusFilter={[STATUS.PUBLISHED, STATUS.SCHEDULED]}
      />
    </div>
  );
}
